import React, { useState } from "react";
import { FileSearch, ArrowRight } from "lucide-react";
import CheckMyFileModal from "./CheckMyFileModal";

/**
 * Ultra-thin promo strip pinned to the absolute top of every public page.
 * Directs high-intent visitors straight into the CheckMyFile funnel — the
 * client's preferred first-touch path.
 */
export default function CheckMyFileTopStrip() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <div
                data-testid="checkmyfile-top-strip"
                className="w-full bg-brand-accent text-white"
            >
                <button
                    type="button"
                    onClick={() => setOpen(true)}
                    data-testid="checkmyfile-top-strip-btn"
                    className="w-full flex items-center justify-center gap-2 md:gap-3 px-4 py-2.5 md:py-3 text-[13px] md:text-sm font-bold uppercase tracking-[0.14em] hover:bg-brand-accent/90 transition-colors group"
                >
                    <FileSearch size={16} className="shrink-0" />
                    <span className="hidden sm:inline">Check your credit file with</span>
                    <span>CheckMyFile — our trusted partner</span>
                    <ArrowRight
                        size={14}
                        className="shrink-0 transition-transform group-hover:translate-x-0.5"
                    />
                </button>
            </div>
            <CheckMyFileModal open={open} onClose={() => setOpen(false)} />
        </>
    );
}
